import { render, staticRenderFns } from "./IconButtonHome.vue?vue&type=template&id=20e1fad2&scoped=true&"
import script from "./IconButtonHome.vue?vue&type=script&lang=js&"
export * from "./IconButtonHome.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonHome.vue?vue&type=style&index=0&id=20e1fad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1fad2",
  null
  
)

export default component.exports